module.exports = "<ea-e-mails-page></ea-e-mails-page>\n"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaAdministration/eaEMails/eaEMailsPage/eaEMailsPageModule.html
// module id = 953
// module chunks = 12